import { TranslateService } from '@ngx-translate/core';

export const pagesLabel = (
  durationUnitType: string,
  translate: TranslateService
) => {
  const units =
    durationUnitType && durationUnitType !== 'Unknown'
      ? translate.instant('Core_' + durationUnitType)
      : translate.instant('Core_Pages');

  return translate.instant('dgOrgInternalContentForm_BookLengthCustomFormat', {
    units: units,
  });
};
